/* eslint-disable no-bitwise */
/* eslint-disable no-plusplus */
/* eslint-disable no-underscore-dangle */
import {
  $getTableColumnIndexFromTableCellNode,
  $getTableNodeFromLexicalNodeOrThrow,
  $getTableRowIndexFromTableCellNode,
  $isTableCellNode, $isTableRowNode, TableCellHeaderStates, TableCellNode,
} from '@lexical/table';
import { MenuItem } from '@mui/material';
import { LexicalEditor } from 'lexical';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface ToggleTableIsHeaderProps {
  activeEditor: LexicalEditor;
  currentNode: TableCellNode;
  onClose: () => void;
  clearTableSelection: () => void;
}
export default function ToggleTableIsHeader(props: ToggleTableIsHeaderProps) {
  const {
    activeEditor, currentNode, onClose, clearTableSelection,
  } = props;
  const { t } = useTranslation('wysiwyg');

  const toggleTableRowIsHeader = React.useCallback(() => {
    activeEditor.update(() => {
      const tableNode = $getTableNodeFromLexicalNodeOrThrow(currentNode);

      const tableRowIndex = $getTableRowIndexFromTableCellNode(currentNode);

      const tableRows = tableNode.getChildren();

      if (tableRowIndex >= tableRows.length || tableRowIndex < 0) {
        throw new Error('Expected table cell to be inside of table row.');
      }

      const tableRow = tableRows[tableRowIndex];

      if (!$isTableRowNode(tableRow)) {
        throw new Error('Expected table row');
      }

      tableRow.getChildren().forEach((tableCell) => {
        if (!$isTableCellNode(tableCell)) {
          throw new Error('Expected table cell');
        }

        tableCell.toggleHeaderStyle(TableCellHeaderStates.ROW);
      });

      clearTableSelection();
      onClose();
    });
  }, [activeEditor, currentNode, clearTableSelection, onClose]);

  const toggleTableColumnIsHeader = React.useCallback(() => {
    activeEditor.update(() => {
      const tableNode = $getTableNodeFromLexicalNodeOrThrow(currentNode);

      const tableColumnIndex = $getTableColumnIndexFromTableCellNode(
        currentNode,
      );

      const tableRows = tableNode.getChildren();

      for (let r = 0; r < tableRows.length; r++) {
        const tableRow = tableRows[r];

        if (!$isTableRowNode(tableRow)) {
          throw new Error('Expected table row');
        }

        const tableCells = tableRow.getChildren();

        if (tableColumnIndex >= tableCells.length || tableColumnIndex < 0) {
          throw new Error('Expected table cell to be inside of table row.');
        }

        const tableCell = tableCells[tableColumnIndex];

        if (!$isTableCellNode(tableCell)) {
          throw new Error('Expected table cell');
        }

        tableCell.toggleHeaderStyle(TableCellHeaderStates.COLUMN);
      }

      clearTableSelection();
      onClose();
    });
  }, [activeEditor, currentNode, clearTableSelection, onClose]);

  return (
    <>
      <MenuItem onClick={() => toggleTableRowIsHeader()}>
        {((currentNode.__headerState & TableCellHeaderStates.ROW) === TableCellHeaderStates.ROW)
          ? (t('table.actions.remove-row-header'))
          : (t('table.actions.add-row-header'))}
      </MenuItem>
      <MenuItem onClick={() => toggleTableColumnIsHeader()}>
        {((currentNode.__headerState & TableCellHeaderStates.COLUMN) === TableCellHeaderStates.COLUMN)
          ? (t('table.actions.remove-column-header'))
          : (t('table.actions.add-column-header'))}
      </MenuItem>
    </>
  );
}
